import React from 'react';
import { Modal } from './Modal';
interface Props {
  open: boolean;
  onClose: () => void;
}
export function TermsOfUseModal({
  open,
  onClose
}: Props) {
  return <Modal open={open} onClose={onClose} title="Terms of Use" data-id="element-81">
      <div className="space-y-4" data-id="element-82">
        <p className="text-xs text-gray-500" data-id="element-83">Last updated: January 2025</p>

        <section data-id="element-84">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-85">
            1. Acceptance of Terms
          </h3>
          <p data-id="element-86">
            By accessing or using this website, you agree to be bound by these
            Terms of Use and our Privacy Policy. If you do not agree, please do
            not use the site.
          </p>
        </section>

        <section data-id="element-87">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-88">2. Eligibility</h3>
          <p data-id="element-89">
            You must be at least 18 years old and a legal resident of the United
            States to use our services. By using this site, you represent that
            you meet these requirements.
          </p>
        </section>

        <section data-id="element-90">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-91">
            3. Nature of Our Service
          </h3>
          <p data-id="element-92">
            This website is a marketing and matching platform. We are not a debt
            relief, debt settlement, credit repair, or law firm. We connect
            consumers with independent providers who may be able to assist with
            their debt situation. Results vary and are not guaranteed.
          </p>
        </section>

        <section data-id="element-93">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-94">
            4. No Professional Advice
          </h3>
          <p data-id="element-95">
            Information provided on this site is for general informational
            purposes only and does not constitute legal, financial, or tax
            advice. Consult a qualified professional before making decisions
            about your debt.
          </p>
        </section>

        <section data-id="element-96">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-97">5. User Conduct</h3>
          <p data-id="element-98">
            You agree to provide accurate, current, and complete information.
            You may not use this site for any unlawful purpose or to interfere
            with its operation.
          </p>
        </section>

        <section data-id="element-99">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-100">
            6. Intellectual Property
          </h3>
          <p data-id="element-101">
            All content on this site, including text, graphics, logos, and
            software, is the property of the site owner or its licensors and is
            protected by copyright and other intellectual property laws.
          </p>
        </section>

        <section data-id="element-102">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-103">
            7. Limitation of Liability
          </h3>
          <p data-id="element-104">
            To the maximum extent permitted by law, we are not liable for any
            indirect, incidental, special, or consequential damages arising from
            your use of this site or the services of any third-party provider we
            refer you to.
          </p>
        </section>

        <section data-id="element-105">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-106">
            8. Changes to Terms
          </h3>
          <p data-id="element-107">
            We reserve the right to update these Terms at any time. Continued
            use of the site after changes are posted constitutes acceptance of
            the revised Terms.
          </p>
        </section>

        <section data-id="element-108">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-109">9. Contact</h3>
          <p data-id="element-110">
            Questions about these Terms? Contact us at{' '}
            <a href="mailto:support@example.com" className="text-blue-700 underline" data-id="element-111">
              support@example.com
            </a>
            .
          </p>
        </section>
      </div>
    </Modal>;
}